import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import CadeComponentHeader from './CadeComponentHeader';
import CadeComponentDoodle from './CadeComponentDoodle';
import authService from '../../services/AuthService';
import api, { apiResponseHandler, apiErrorHandler } from '../../services/AxiosService';
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Legend, Tooltip} from 'recharts';

import './CadeInput.css';
import { apiErrorPopup } from '../../helpers/MessagePopup';


class CadeInputAssessmentComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            totalItems: 0,
            numItemsAnswered: 0,
            numItemsNotAnswered: 0,
            pctItemsAnswered: 0,
            pctItemsNotAnswered: 0,
            numItemsCgAnswered: 0,
            numItemsCgNotAnswered: 0,
            pctItemsCgAnswered: 0,
            pctItemsCgNotAnswered: 0,
            domainSummary: []
        }
    }

    componentDidMount = () => {
        /*
         * Run a query to get summary domain input information (overall progress and per domain) 
         */
        
        let url = "assessment/" + this.props.assessmentId + "/input/" + authService.userType;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then((response) => {
                if (response.status == 200) {
                    this.setState({
                        totalItems: response.data.totalItems,
                        numItemsAnswered: response.data.numItemsAnswered,
                        numItemsNotAnswered: response.data.numItemsNotAnswered,
                        pctItemsAnswered: response.data.pctItemsAnswered,
                        numItemsCgAnswered: response.data.numItemsCgAnswered,
                        numItemsCgNotAnswered: response.data.numItemsCgNotAnswered,
                        pctItemsCgAnswered: response.data.pctItemsCgAnswered,
                        domainSummary: response.data.domainSummary
                    })
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));
            });
    }
    render() {
        let domainSummary = this.state.domainSummary.map((item, index) => {
            let newItem = { name: item.domainName, exResponse: item.pctItemsAnswered, exNoResponse: item.pctItemsNotAnswered, cgResponse: item.pctItemsCgAnswered, cgNoResponse: item.pctItemsCgNotAnswered };
            return newItem;
        });
       
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentHeader
                                cadeDomain="CADE Assessment"
                                subTitle="Input Summary"
                            />
                        </Col>
                        <Col sm={8}>
                           
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentDoodle
                                domainImage="CadeAssessmentLG.png"
                                resClickHandler={null}
                                resources={null}
                                resKey={0}
                            />
                        </Col>
                        <Col sm={8}>
                            <h4>Overall Response Summary</h4>
                            <p className="cadeInput_DomainSummaryFootnote"></p>
                            <Card bsPrefix = "cadeInput_DomainSummaryCard">
                                <Card.Body>
                                    <Row>
                                        <Col sm={9}>
                                            <p className="cadeInput_DomainSummaryItem">Total number of items</p>
                                        </Col>
                                        <Col sm={3}>
                                            <p className="cadeInput_DomainSummaryItem cadeInput_DomainSummaryItemValue">{this.state.totalItems}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={9}>
                                            <p className="cadeInput_DomainSummaryItem">Number of responses</p>
                                        </Col>
                                        <Col sm={3}>
                                            <p className="cadeInput_DomainSummaryItem cadeInput_DomainSummaryItemValue">{this.state.numItemsAnswered}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={9}>
                                            <p className="cadeInput_DomainSummaryItem">Percentage of responses</p>
                                        </Col>
                                        <Col sm={3}>
                                            <p className="cadeInput_DomainSummaryItem cadeInput_DomainSummaryItemValue">{this.state.pctItemsAnswered}%</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={9}>
                                            <p className="cadeInput_DomainSummaryItem">Required items needing a response</p>
                                        </Col>
                                        <Col sm={3}>
                                            <p className="cadeInput_DomainSummaryItem cadeInput_DomainSummaryItemValue" style={{ color: "red" }}>{this.state.numItemsNotAnswered}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="cadeInput_AssessmentGraphRow">
                        <Col sm={12}>
                            <h4 style={{ marginTop: "20px" }}>Percent Complete</h4>
                            <ResponsiveContainer height={900}>
                                <BarChart width="100%" layout="vertical" barCategoryGap={20} barGap={8} data={domainSummary}
                                    margin={{ top: 20, right: 0, left: 100, bottom: 0}}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <YAxis type="category" dataKey="name" tick={{ fontWeight: "bold" }} interval={0} />
                                    <XAxis type="number" domain={[0, 100]}/>
                                    <Tooltip />
                                    <Legend/>
                                    <Bar name="Examiner Pct Complete" dataKey="exResponse" stackId="a" fill="blue" barSize={15} fillOpacity={0.70} />
                                    {false &&  <Bar name="Caregiver Pct Complete" dataKey="cgResponse" stackId="a" fill="tan" barSize={15} fillOpacity={0.70} />}
                                </BarChart>
                                
                            </ResponsiveContainer>
                        </Col>
                    </Row>
                 
                </Container>

            </Fragment>
        );
    }
}

export default CadeInputAssessmentComponent;

/* Example graphs
 * 
 * <BarChart width="100%" layout="vertical" barCategoryGap={20} barGap={8} data={domainSummary}
                                    margin={{ top: 20, right: 0, left: 100, bottom: 0}}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <YAxis type="category" dataKey="name" tick={{ fontWeight: "bold" }} interval={0} />
                                    <XAxis type="number" domain={['0', '100']}/>
                                    <Tooltip />
                                    <Legend/>
                                    <Bar name="Examiner 1 or more responses %" dataKey="exResponse" stackId="a" fill="blue" barSize={15} fillOpacity={0.70} />
                                    <Bar name="Examiner no responses %" dataKey="exNoResponse" stackId="a" fill="deepskyblue" barSize={15} fillOpacity={0.70} />
                                    <Bar name="Caregiver 1 or more responses %" dataKey="cgResponse" stackId="b" fill="tan" barSize={15} fillOpacity={0.70}  />
                                    <Bar name="Caregiver no responses %" dataKey="cgNoResponse" stackId="b" fill="wheat" barSize={15} fillOpacity={0.70}  />
                                </BarChart>

 * const domainColors = ["red", "green"];
    let domainData = [
        { "name": "One or more", "value": this.state.domainsAnswered },
        { "name": "No responses", "value": this.state.domainsNotAnswered }
    ];
    let domainDataCells = domainData.map((entry, index) => <Cell fill={domainColors[index % domainColors.length]} />);

 * <PieChart width={200} height={200}>
    <Pie
        data={domainData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        startAngle={180}
        endAngle={0}
        innerRadius={40}
        outerRadius={60}
        paddingAngle={5}
        label
        labelLine={false}
    >
        {domainDataCells}
    </Pie>
</PieChart>
*/



// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeInputAssessmentComponent.js